import { QuotationTask } from '@/hooks/api/models';
import axios from '@/lib/axios';
import { useMutation } from '@tanstack/react-query';

/**
 * 1604. 見積タスクMF見積書連携
 * [POST] /workspaces/:identifier/teams/:team_id/sales_orders/:sales_order_id/quotation_tasks/:quotation_task_id/create_mf_quote
 */
type Props = {
  identifier: string;
  team_id: number;
  sales_order_id: number;
  task_id: number;
};

const createMoneyForwardQuotation = (props: Props): Promise<QuotationTask> => {
  return axios.post(
    `/api/workspaces/${props.identifier}/teams/${props.team_id}/sales_orders/${props.sales_order_id}/quotation_tasks/${props.task_id}/create_mf_quote`,
    props
  );
};

export const useCreateMoneyForwardQuotation = () => {
  return useMutation({
    mutationFn: createMoneyForwardQuotation,
  });
};
